import { useState, useEffect } from 'react';
import { createTheme } from '@mui/material/styles';
import { useThemeStore } from '../stores/themeStore';
import type { ThemeMode } from '../stores/themeStore';

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#6366f1' },
    secondary: { main: '#f59e0b' },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#818cf8' },
    secondary: { main: '#fbbf24' },
  },
});

export function useThemeMode(): [ThemeMode, (mode: ThemeMode) => void] {
  const mode = useThemeStore((s) => s.mode);
  const setMode = useThemeStore((s) => s.setMode);
  return [mode, setMode];
}

export function useResolvedMode(): 'light' | 'dark' {
  const mode = useThemeStore((s) => s.mode);
  const [systemDark, setSystemDark] = useState(
    () => window.matchMedia('(prefers-color-scheme: dark)').matches,
  );

  useEffect(() => {
    if (mode !== 'system') return;

    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e: MediaQueryListEvent) => setSystemDark(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [mode]);

  return mode === 'system' ? (systemDark ? 'dark' : 'light') : mode;
}
